import { isEqual, debounce, noop, omit } from "lodash";
import * as React from "react";

// component that calls its onChange prop when the value prop changes, with optional debounce

interface Props<T = any> {
  onChange?: (value: T) => void;
  value: T;
  debounce?: number;
  propertiesToOmitFromDiff?: string[];
}

class OnChangeComponent<T = any> extends React.Component<Props<T>> {
  debouncedOnChange = this.createDebouncedOnChange();
  
  createDebouncedOnChange() {
    const { onChange = noop, debounce: debounceValue } = this.props;
    return (this.debouncedOnChange = debounce(value => {
      onChange(value);
    }, debounceValue));
  }

  componentDidMount() {
    this.createDebouncedOnChange();
  }

  componentDidUpdate(prevProps) {
    const props = this.props;
    if (
      prevProps.onChange !== props.onChange ||
      prevProps.debounce !== props.debounce
    ) {
      this.createDebouncedOnChange();
    }

    let prev = prevProps.value;
    let current = props.value as any;

    if (props.propertiesToOmitFromDiff) {
      prev = omit(prevProps.value, props.propertiesToOmitFromDiff);
      current = omit(props.value as any, props.propertiesToOmitFromDiff);
    }

    if (!isEqual(prev, current)) {
      this.debouncedOnChange(props.value);
    }
  }

  render() {
    return null;
  }
}

export default OnChangeComponent;



// WEBPACK FOOTER //
// ./app/javascript/components/utility/OnChangeComponent.tsx